export const SET_ACCOUNT_DETAILS = "SET_ACCOUNT_DETAILS";
export const SET_USER_DETAILS = "SET_USER_DETAILS";
export const SET_USER_BILLING_DETAILS = "SET_USER_BILLING_DETAILS";
export const SET_USER_CARD_DETAILS = "SET_USER_CARD_DETAILS";
export const SET_USER_WORKOUT_HISTORY = "SET_USER_WORKOUT_HISTORY";
export const SET_USER_SURVEY = "SET_USER_SURVEY";
export const SET_FAVORITES_IDS = "SET_FAVORITES_IDS";
export const SET_FINISHED_WORKOUTS_IDS = "SET_FINISHED_WORKOUTS_IDS";
export const SET_LATEST_SURVEY_SCORES = "SET_LATEST_SURVEY_SCORES";
export const SET_USER_CHILD_DETAILS = "SET_USER_CHILD_DETAILS";
export const SET_SELECTED_PROGRAM = "SET_SELECTED_PROGRAM";
export const SET_USER_ALL_WORKOUT_HISTORY = "SET_USER_ALL_WORKOUT_HISTORY";
export const SET_USER_ALL_WORKOUT_HISTORY_WITH_ARCHIVED = "SET_USER_ALL_WORKOUT_HISTORY_WITH_ARCHIVED";

export const SET_SURVEY_QUESTIONS = "SET_SURVEY_QUESTIONS";
export const SET_SELECTED_PROGRAMS = "SET_SELECTED_PROGRAMS";
export const SET_USER_NOTIFICATIONS = "SET_USER_NOTIFICATIONS";

export const SET_INVITATION_DETAILS = "SET_INVITATION_DETAILS";
export const SET_PATIENT_EMAIL_DETAILS = "SET_PATIENT_EMAIL_DETAILS";
export const SET_SURVEY_GOALS = "SET_SURVEY_GOALS";
